import React, { useEffect, useState } from 'react';

export default function PaymentCallback() {
  const [message, setMessage] = useState('İşlem sonucu işleniyor...');

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const status = (params.get('status') || '').toLowerCase();
      const provider = params.get('provider') || 'iyzico';
      const token = params.get('token') || params.get('paymentId') || '';

      const payload = { provider, status, token };
      // Parent sayfaya sonuç gönder
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: 'PAYMENT_RESULT', ...payload }, '*');
      }
      setMessage(status === 'success' ? 'Ödeme başarılı. Pencere kapanıyor...' : 'Ödeme başarısız veya iptal edildi.');

      // Kısa gecikme ile pencereyi kapat
      setTimeout(() => {
        window.close();
      }, 1200);
    } catch (e) {
      setMessage('İşlem sonucu alınamadı.');
    }
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      {message}
    </div>
  );
}
